import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';
import { bus } from '@/util/event-bus';

export default async({ Vue, store }) => {
   if (process.env.NODE_ENV === 'production') {
      bus.$on('auth-ok', () => {
         const { email } = store.getters['auth/verifiedUser'];

         Sentry.setUser({ email });
         Sentry.init({
            dsn: process.env.SENTRY_DSN,
            release: process.env.RELEASE_SHA,
            environment: process.env.SENTRY_ENVIRONMENT || 'production',
            integrations: [
               new VueIntegration({
                  Vue,
                  tracing: true,
                  tracingOptions: {
                     trackComponents: true,
                  },
               }),
               new Integrations.BrowserTracing(),
            ],
            tracesSampleRate: 1.0,
         });
      });
   }
};
